import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import ProgressBar from '../ProgressBar';
import MotoIcon from '../MotoIcon';
import AutoIcon from '../AutoIcon';
import { selectMoto, selectAuto, setClientData } from '../../actions';
import Select from 'react-select'
import 'bootstrap/dist/css/bootstrap.min.css';
const Grupos = [
  {label: "AEFIP", value: 1},
];


const Paso1 = () => {
  const dispatch = useDispatch();

  const cliente = useSelector((state) => state.cliente);

  const urlParams = new URLSearchParams(window.location.search)
  const url_afinidad = urlParams.get('afinidad')

  const [afinidad, setAfinidad] = useState(url_afinidad || cliente.afinidad);
  
  const handleClick = (vehiculo) => {
    dispatch(setClientData({
      afinidad,
    }))
    if (vehiculo === 'moto') {
      if (typeof(afinidad) != 'undefined'){
        dispatch(selectMoto());
      } else {
        alert('Debe seleccionar el grupo de afinidad al que pertenece.');
      }
      //window.open("https://cover-it.com.ar/motos/","blank");
    } else if (vehiculo === 'auto') {
      if (typeof(afinidad) != 'undefined'){
        dispatch(selectAuto());
      } else {
        alert('Debe seleccionar el grupo de afinidad al que pertenece.');
      }
    }
  };

  const handleChangeAfinidad = (e) => {
    setAfinidad(e.label);
  };

  
  return (
    <>
      <Container>
        <ProgressBar percentaje="p1" value="1 de 6" />

        <Title>
          ¿Qué vas a
          {' '}
          <TitleMod>cotizar</TitleMod>
          ?
        </Title>

        <OptionsList>
          <OptionsListItem>
            <Link className="link" to="/2/" onClick={() => handleClick('moto')}>
              <MotoIcon color="azul" />
            </Link>
          </OptionsListItem>
          <OptionsListItem>
            <Link className="link" to="/2/" onClick={() => handleClick('auto')}>
              <AutoIcon color="azul" />
            </Link>
          </OptionsListItem>
        </OptionsList>

        <Disclaimer>
          * Coberturas previstas solo para vehículos particulares
        </Disclaimer>
        <Disclaimer>
          <Disclaimer>
          <Select 
            options={Grupos} 
            placeholder="Seleccione el Grupo de Afinidad al que pertenece."
            onChange={handleChangeAfinidad}
            required
            />
          </Disclaimer>
        </Disclaimer>
      </Container>
    </>
  );
};

export default Paso1;

/*
 *
 *
 * STYLES
 *
 *
*/

const Container = styled.div`
  padding: 30px 15px;
`;

const Title = styled.p`
  margin-top: 92px;
  margin-bottom: 80px;
  font-weight: 300;
  color: var(--azul);
  text-align: center;
  font-size: 28px;
`;

const TitleMod = styled.span`
  color: var(--verde);
`;

const Input = styled.input`
  display: block;
  text-align: center;
  width: 100%;
  font-size: 18px;
  color: var(--gris);
  padding: 5px;
  border: 1px solid var(--verde);
`;


const OptionsList = styled.ul`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const OptionsListItem = styled.li`
  width: 130px;
  height: 130px;
  border: 1px solid var(--verde);
  border-radius: 50%;
  margin: 0 20px;
  &:active {
    background: var(--verde);
  }
  & .link {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const Disclaimer = styled.p`
  color: var(--azul);
  font-size: 14px;
  width: 60%;
  margin: 40px auto 24px;
  text-align: center;
`;
